import { Injectable, signal } from '@angular/core';

export type PlanEditLeaveAnswer = 'save' | 'discard' | 'stay';

/** State behind the "leave the plan with unsaved edits?" dialog; rendered once by the root layout. */
@Injectable({ providedIn: 'root' })
export class PlanEditLeavePromptService {
  readonly open = signal(false);
  private resolve: ((answer: PlanEditLeaveAnswer) => void) | null = null;

  ask(): Promise<PlanEditLeaveAnswer> {
    // A second navigation while the dialog is open supersedes the first.
    this.answer('stay');
    this.open.set(true);
    return new Promise<PlanEditLeaveAnswer>((resolve) => (this.resolve = resolve));
  }

  answer(answer: PlanEditLeaveAnswer): void {
    this.open.set(false);
    this.resolve?.(answer);
    this.resolve = null;
  }
}
